<template>
    <div class="base-card__content ondemand-content">
        <div class="ondemand-content__image-skeleton"/>
        <div class="ondemand-content__name-skeleton"/>
    </div>
</template>
